import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

/**
 * Emblem mark on a dark disc. The disc matches the input surface in dark
 * mode; light mode keeps the solid dark disc for contrast with the pale
 * green mark.
 */
export function AssistantEmblem({ emblemWidth, size }: { emblemWidth?: number; size: number }) {
	const theme = useTheme()
	return (
		<Box
			sx={{
				alignItems: 'center',
				bgcolor: theme.palette.mode === 'dark' ? 'background.level1' : 'text.primary',
				borderRadius: '50%',
				display: 'flex',
				flexShrink: 0,
				height: size,
				justifyContent: 'center',
				width: size,
			}}
		>
			<Box
				alt=""
				component="img"
				src="/assets/logo-emblem.svg"
				sx={{ display: 'block', height: 'auto', width: emblemWidth ?? Math.round(size * 0.57) }}
			/>
		</Box>
	)
}
